import { ResolverService } from './services/resolver.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { CoachComponent } from './coach/coach.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { FaqComponent } from './components/faq/faq.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { RegisterComponent } from './components/register/register.component';
import { ParentComponent } from './parent/parent.component';
import { StudentComponent } from './student/student.component';
import { AuthGuard } from './guards/auth-guard.service';
import { ContactUsComponent } from './components/contact-us/contact-us.component';

const appRoutes: Routes = [{
  path: 'admin',
  component: AdminComponent,
  canActivate: [AuthGuard],
  resolve: { resolverData: ResolverService },
  loadChildren: './admin/admin.module#AdminModule'
}, {
  path: 'coach',
  component: CoachComponent,
  canActivate: [AuthGuard],
  resolve: { resolverData: ResolverService },
  loadChildren: './coach/coach.module#CoachModule'
}, {
  path: 'student',
  component: StudentComponent,
  canActivate: [AuthGuard],
  resolve: { resolverData: ResolverService },
  loadChildren: './student/student.module#StudentModule'
}, {
  path: 'parent',
  component: ParentComponent,
  canActivate: [AuthGuard],
  resolve: { resolverData: ResolverService },
  loadChildren: './parent/parent.module#ParentModule'

}, {
  path: 'login',
  component: LoginComponent,
  resolve: { resolverData: ResolverService }
},
{
  path : 'password-recovery',
  component : PasswordRecoveryComponent,
},
{
  path: 'register',
  component: RegisterComponent
}, {
  path: '',
  redirectTo: '/login',
  pathMatch: 'full',
},
{
  path: 'pageNotFound',
  component: PageNotFoundComponent,
  resolve: { resolverData: ResolverService }
}, {
  path: 'accessDenied',
  component: AccessDeniedComponent
}, {
  path: 'faq',
  component: FaqComponent
},
{
  path: 'contact-us',
  component: ContactUsComponent
},
{
  path: '**',
  component: PageNotFoundComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
